<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
    <v-select :class="[editarE ? 'quitarborde' : '' , i == 0 || i == 1 ? 'estilo_vs_tratamiento_derecha' : 'estilo_vs_tratamiento_izquierda']" id="tratamiento1"
              name="tratamiento1" placeholder="Agregar tratamiento"
              v-model="item.idTratamiento"
              :options="catTratamientos"
              :disabled="editarE || disable"
              :clearable="!editarE"
              :noDrop="editarE"
              @input="actualizarRuta"
              :reduce="(variable) => variable.idTratamiento"
              label="nombre"
              solo
    ></v-select>

    </div>
    <template v-if="!editarE">
      <b-input  style="width: 20%" :disabled="disable" min="1"
               type="number" v-model="item.cantidad"></b-input>
      <b-button v-if="!disable" size="sm" v-b-tooltip.hover title="Eliminar Tratamiento"
                style="color: red !important;" variant="link"
                @click="eliminarTratamiento(item)">
        <font-awesome-icon icon="times-circle"/>
      </b-button>
    </template>

  </div>
</template>

<script>
export default {
  name: "SelectTratamiento",
  props:{
    item: Object,
    catTratamientos: Array,
    editarE:Boolean,
    disable:Boolean,
    idEtapa: Number,
    idPadecimiento: Number,
    i:Number
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    entroAEliminar: false,
  }),
  computed:{
    idTratamiento(){
      return this.item.idTratamiento != null ? this.item.idTratamiento : null
    }
  },
  watch:{

     idTratamiento(newTratamiento, oldTratamiento){

       if (oldTratamiento !== null && oldTratamiento !== undefined && !this.entroAEliminar){
         this.$emit('guardarBitacoraCambios', 1, this.idPadecimiento, oldTratamiento)
       }
     },
  },

  methods:{
    actualizarRuta() {
      this.$emit('actualizarRuta')
      this.item.modificado = true;
    },
    eliminarTratamiento(item) {
      this.entroAEliminar = true;
      this.$emit('eliminarTratamiento', item)
    },

  },

  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style>
.estilo_vs_tratamiento_derecha .vs__dropdown-menu {
  width: 200% !important;
  left: 0;
  right: auto;
  font-size: small;
}
.estilo_vs_tratamiento_izquierda .vs__dropdown-menu {
  width: 200% !important;
  left: auto;
  right: 0;
  font-size: small;
}
</style>
